

import React, { useState } from 'react';
export default function CareerPaths() {
  return (
    <section id="careers" className="bg-white dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-2xl md:text-3xl font-bold">Step into Your Future Dream Job</h2>
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {['AI Product Engineer','ML Engineer','Data Scientist','Cloud DevOps'].map(p => (
            <div key={p} className="path-card p-4 text-center reveal">{p}</div>
          ))}
        </div>
      </div>
    </section>
  );
}
